
import {single} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';




const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class RegisterDelayService {

    constructor(private authService: AuthService, private http: HttpClient) {
    }

    public postDelayRegistration(client_order_num: string, ETA: Date, clientCode: string, message: string): Promise<object> {
        if (this.authService.user.hasRole('employee')) {
            var body = {
                'client_order_num': client_order_num,
                'date': ETA,
                'clientCode': clientCode,
                'message': message,
            };
            var retVal = this.http.post('/api/service/delay/', body, httpOptions).pipe(single()).toPromise()
        }

        return retVal;
    }

    public postGetToken(client_code: string): Promise<object> {
        let retVal;
        if (this.authService.user.hasRole('employee')) {
            let body = {
                'clientCode': client_code,
            };
            retVal = this.http.post('/api/service/getToken/', body, httpOptions).pipe(single()).toPromise()
        } else {
            retVal = false;
        }

        return retVal;
    }
}
